export default __webpack_public_path__ + "static/media/Hybrid.4292cef8.png";